import Dashboard from "@/views/Dashboard";
import store from "@/store";

export default [
  {
    path: "/organization/:organizationId(\\d+)/dashboard",
    name: "dashboard",
    component: Dashboard,
    props: true,
    beforeEnter: (to, from, next) => {
      const goToOnboarding = store.getters["user/showOnboarding"] && !store.getters["user/isElsaAdmin"];
      if (goToOnboarding) {
        return next({ name: "onboarding" });
      }
      const organizationId = to.params.organizationId || store.getters["organization/currentOrganizationId"];
      if (organizationId) {
        return next();
      }
      return next("/");
    },
    meta: {
      menuItemIndex: '7',
      title:'Dashboard'
    }
  },
  {
    path: "/",
    component: Dashboard,
    props: true,
    meta: {
      menuItemIndex: '7'
    }
  },
];
